import { useEffect } from 'react';
import { getCurrentAIScribe } from 'store/aiScribe/aiScribeActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import transcribedScreenImage from 'assets/png/aiScribeBackground.png';
import { useResponsive } from 'utils/hooks/useMediaQuery';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSearchParams } from 'react-router-dom';

import { AiScribeDrawer } from './drawer';
import { AiScribeModal } from './modal';
import { NewAiScribeDrawer } from './newDrawer';
import { AiScribeProvider } from './context/useAiScribe';

const AiScribeContent = () => {
  const [searchParams] = useSearchParams();
  const { enableMpiUpdate } = useFlags();
  const { isTablet } = useResponsive();
  const { state } = useAppSelector((s) => s.aiScribe);
  const context = searchParams.get('context');

  if (state == null || context === 'popup') return null;

  if (isTablet && !enableMpiUpdate) {
    return <AiScribeDrawer />;
  }

  if (isTablet && enableMpiUpdate) {
    return <NewAiScribeDrawer />;
  }

  if (!enableMpiUpdate) return null;

  return <AiScribeModal />;
};

const AiScribe = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getCurrentAIScribe());

    // Preload transcribed screen image
    const img = new Image();
    img.src = transcribedScreenImage;
  }, []);

  return (
    <AiScribeProvider>
      <AiScribeContent />
    </AiScribeProvider>
  );
};

export default AiScribe;
